import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../config/axiosInterceptor";

const animCSS = `
@keyframes fadeInRow {
  from { opacity: 0; transform: translateY(30px);}
  to   { opacity: 1; transform: translateY(0);}
}
@keyframes pulse {
  0% { color: #1677ff; }
  50% { color: #52c41a; }
  100% { color: #1a1a1a; }
}
@keyframes spin {
  to { transform: rotate(360deg);}
}
`;

const RechargeHistory = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [filterType, setFilterType] = useState("all");
  const [search, setSearch] = useState("");
  const getDefaultStartDate = () => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
  };
  const getDefaultEndDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(getDefaultEndDate());
  const [total, setTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [adminrechargeHistory, setAdminrechargeHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRechargeHistory = async () => {
    try {
      setLoading(true);

      let url = `${process.env.REACT_APP_BASEURL1}/admin/recharge/getrechargeHistory?page=${currentPage}&limit=${entriesPerPage}`;
      if (filterType === "users") url += `&type=2`;
      else if (filterType === "coin") url += `&type=1`;
      if (search) url += `&search=${search}`;
      if (startDate) url += `&startDate=${startDate}T00:00:00`;
      if (endDate) url += `&endDate=${endDate}T23:59:59`;

      const { data } = await axiosInstance.get(url);
      setAdminrechargeHistory(data.data);
      setTotal(data.total);
      setTotalAmount(data.totalAmount || 0);
      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRechargeHistory();
    // eslint-disable-next-line
  }, [currentPage, entriesPerPage]);

  const totalPages = Math.ceil(total / entriesPerPage);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li key={i} style={{
          display: "inline-block",
          margin: "0 4px"
        }}>
          <button
            onClick={() => setCurrentPage(i)}
            style={{
              padding: "6px 16px",
              borderRadius: 6,
              border: "none",
              fontWeight: 600,
              background: currentPage === i ? "#1677ff" : "#f5faff",
              color: currentPage === i ? "#fff" : "#444",
              boxShadow: currentPage === i ? "0 2px 12px #1677ff22" : "",
              cursor: "pointer",
              transition: "all 0.17s"
            }}
          >
            {i}
          </button>
        </li>
      );
    }
    return pageNumbers;
  };

  const submitHandler = async (dataDetails) => {
    try {
      const { data } = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/return/coins`,
        dataDetails
      );
      if (data.success === "1") {
        toast.success(data.message);
        fetchRechargeHistory();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Amount animation
  const [displayAmount, setDisplayAmount] = useState(0);
  useEffect(() => {
    let start = displayAmount;
    let end = totalAmount;
    let frame;
    const duration = 500;
    const step = (ts, startTs) => {
      let elapsed = ts - startTs;
      let progress = Math.min(elapsed / duration, 1);
      let val = Math.round(start + (end - start) * progress);
      setDisplayAmount(val);
      if (progress < 1) {
        frame = requestAnimationFrame((now) => step(now, startTs));
      }
    };
    if (start !== end) {
      frame = requestAnimationFrame((now) => step(now, now));
    }
    return () => frame && cancelAnimationFrame(frame);
    // eslint-disable-next-line
  }, [totalAmount]);

  return (
    <>
      <style>{animCSS}</style>
      <section style={{ background: "#f8fafb", padding: "36px 0 0" }}>
        {/* Breadcrumb */}
        <div style={{
          maxWidth: 1200, margin: "0 auto", marginBottom: 14, padding: "0 18px"
        }}>
          <h1 style={{
            fontSize: 32, fontWeight: 700, color: "#234", letterSpacing: 0.6, marginBottom: 2
          }}>Recharge History</h1>
          <ol style={{ listStyle: "none", display: "flex", gap: 12, fontSize: 16, color: "#888" }}>
            <li>
              <Link to="/admin" style={{ color: "#1677ff", textDecoration: "none" }}>
                <i className="fa fa-dashboard"></i> Home
              </Link>
            </li>
            <li style={{ color: "#234" }}>/ Recharge History</li>
          </ol>
        </div>

        {/* Filters */}
        <div style={{
          maxWidth: 1200, margin: "0 auto", marginBottom: 10,
          background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px #1677ff14",
          padding: "22px 20px 16px", display: "flex", flexWrap: "wrap", gap: 28, alignItems: "flex-end"
        }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 500, color: "#555" }}>Filter Type:</label>
            <select
              value={filterType}
              onChange={e => { setFilterType(e.target.value); setCurrentPage(1); }}
              style={{
                width: "100%", padding: "8px 14px", borderRadius: 7,
                border: "1.5px solid #b8daff", background: "#fafdff",
                fontSize: 15, marginTop: 4, outline: "none"
              }}
            >
              <option value="all">All</option>
              <option value="users">Users</option>
              <option value="coin">Coin Agency</option>
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 500, color: "#555" }}>Start Date:</label>
            <input
              type="date"
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              style={{
                width: "100%", padding: "8px 14px", borderRadius: 7,
                border: "1.5px solid #b8daff", background: "#fafdff",
                fontSize: 15, marginTop: 4, outline: "none"
              }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontWeight: 500, color: "#555" }}>End Date:</label>
            <input
              type="date"
              value={endDate}
              onChange={e => setEndDate(e.target.value)}
              style={{
                width: "100%", padding: "8px 14px", borderRadius: 7,
                border: "1.5px solid #b8daff", background: "#fafdff",
                fontSize: 15, marginTop: 4, outline: "none"
              }}
            />
          </div>
          <div style={{ flex: 2, display: "flex", gap: 18, alignItems: "flex-end" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontWeight: 500, color: "#555" }}>Search:</label>
              <input
                type="text"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search"
                style={{
                  width: "100%", padding: "8px 14px", borderRadius: 7,
                  border: "1.5px solid #b8daff", background: "#fafdff",
                  fontSize: 15, marginTop: 4, outline: "none"
                }}
              />
            </div>
            <button
              onClick={fetchRechargeHistory}
              style={{
                marginTop: 16,
                height: 39,
                padding: "0 38px",
                background: "#1677ff",
                color: "#fff",
                fontWeight: 600,
                border: "none",
                borderRadius: 7,
                fontSize: 16,
                boxShadow: "0 2px 10px #1677ff1a",
                transition: "background 0.2s, transform 0.1s",
                cursor: "pointer"
              }}
              onMouseDown={e => e.currentTarget.style.transform = "scale(0.96)"}
              onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
            >
              Apply Filter
            </button>
          </div>
          <div style={{ flex: 1.4, textAlign: "right" }}>
            <div style={{
              fontSize: 18,
              marginBottom: 6,
              color: "#666"
            }}>
              <b>Entries:</b> {total}
            </div>
            <div style={{
              fontSize: 19,
              fontWeight: 700,
              animation: "pulse 1.5s",
              color: "#234"
            }}>
              <b>Amount:</b> <span style={{ color: "#52c41a" }}>{displayAmount}</span>
            </div>
          </div>
        </div>

        {/* Entries per page */}
        <div style={{
          maxWidth: 1200, margin: "0 auto 14px", background: "#fff",
          borderRadius: 12, boxShadow: "0 2px 10px #1677ff0b", padding: "12px 18px 6px", display: "flex", alignItems: "center", gap: 18
        }}>
          <label style={{ fontWeight: 500, color: "#555", marginRight: 6 }}>Entries per page:</label>
          <select
            value={entriesPerPage}
            onChange={e => { setEntriesPerPage(parseInt(e.target.value)); setCurrentPage(1); }}
            style={{
              padding: "7px 16px", borderRadius: 6, border: "1.2px solid #b8daff", fontSize: 15,
              background: "#fafdff", outline: "none"
            }}
          >
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </div>

        {/* Table */}
        <div style={{
          maxWidth: 1200, margin: "0 auto", borderRadius: 14,
          background: "#fff", boxShadow: "0 6px 28px #1677ff12",
          padding: "22px 12px 10px", marginBottom: 30, marginTop: 12,
          overflowX: "auto"
        }}>
          <table style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            fontSize: 16
          }}>
            <thead>
              <tr style={{
                background: "#f0f5ff",
                color: "#222",
                fontWeight: 700
              }}>
                <th style={{ padding: 12 }}>Sr.</th>
                <th style={{ padding: 12 }}>Image</th>
                <th style={{ padding: 12 }}>To</th>
                <th style={{ padding: 12 }}>Username</th>
                <th style={{ padding: 12 }}>Coin</th>
                <th style={{ padding: 12 }}>Date/Time</th>
                <th style={{ padding: 12 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="7" style={{
                    textAlign: "center", fontSize: 19, padding: "54px 0"
                  }}>
                    <div style={{
                      width: 38, height: 38, border: "4px solid #1677ff33",
                      borderTop: "4px solid #1677ff",
                      borderRadius: "50%",
                      margin: "0 auto 16px",
                      animation: "spin 1s linear infinite"
                    }} />
                    Loading...
                  </td>
                </tr>
              ) : (
                adminrechargeHistory?.map((item, index) => (
                  <tr key={item._id}
                    style={{
                      background: index % 2 === 0 ? "#fafcff" : "#f6f9fc",
                      animation: `fadeInRow 0.8s ${(index + 1) * 80}ms both`
                    }}>
                    <td style={{ padding: 9, textAlign: "center", fontWeight: 500 }}>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                    <td style={{ padding: 9 }}>
                      <img
                        src={`${process.env.REACT_APP_BASEURL}${item.image}`}
                        style={{ height: "56px", width: "56px", borderRadius: "50%", boxShadow: "0 2px 10px #1677ff1c" }}
                        alt="User"
                      />
                    </td>
                    <td style={{ padding: 9, fontWeight: 500 }}>
                      {item.to == 2 ? "User" : "Coin Agency"}
                    </td>
                    <td style={{ padding: 9 }}>{item.userId}</td>
                    <td style={{
                      padding: 9,
                      color: "#52c41a",
                      fontWeight: 700,
                      fontSize: 18
                    }}>
                      {item.coin}
                    </td>
                    <td style={{ padding: 9 }}>{new Date(item.createdAt).toLocaleString()}</td>
                    <td style={{ padding: 7 }}>
                      <button
                        style={{
                          background: "#ff4d4f",
                          color: "#fff",
                          fontWeight: 700,
                          border: "none",
                          padding: "7px 18px",
                          borderRadius: 6,
                          fontSize: 16,
                          cursor: "pointer",
                          boxShadow: "0 1px 6px #ff4d4f33",
                          transition: "background 0.18s, transform 0.1s"
                        }}
                        onClick={() => {
                          const res = window.confirm(`Are you sure you want to return coin for 
                            User: ${item.userId}?
                            Amount: ${item.coin}
                          `);
                          if (res) submitHandler({ id: item._id });
                        }}
                        onMouseDown={e => e.currentTarget.style.transform = "scale(0.96)"}
                        onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
                      >
                        Return
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div style={{
          maxWidth: 1200, margin: "0 auto", display: "flex",
          alignItems: "center", justifyContent: "space-between",
          marginTop: 12, gap: 14
        }}>
          <div>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                padding: "8px 28px",
                borderRadius: 6,
                border: "none",
                fontWeight: 600,
                background: currentPage === 1 ? "#f1f2f5" : "#1677ff",
                color: currentPage === 1 ? "#888" : "#fff",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                marginRight: 6,
                boxShadow: "0 1px 8px #1677ff12",
                transition: "background 0.17s"
              }}
            >
              Previous
            </button>
            <ul style={{
              display: "inline-block",
              margin: 0,
              padding: 0,
              listStyle: "none",
              verticalAlign: "middle"
            }}>{renderPageNumbers()}</ul>
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{
                padding: "8px 28px",
                borderRadius: 6,
                border: "none",
                fontWeight: 600,
                background: currentPage === totalPages ? "#f1f2f5" : "#1677ff",
                color: currentPage === totalPages ? "#888" : "#fff",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                marginLeft: 6,
                boxShadow: "0 1px 8px #1677ff12",
                transition: "background 0.17s"
              }}
            >
              Next
            </button>
          </div>
          <div style={{ fontWeight: 500, color: "#234" }}>
            Total entries: <b>{total}</b>
          </div>
        </div>
      </section>
    </>
  );
};

export default RechargeHistory;
